export enum Spaces {
  None = '0',
  XXS = '4px',
  XS = '8px',
  S = '16px',
  M = '24px',
  L = '32px',
  XL = '48px',
  XXL = '64px',
  XXXL = '128px'
}
